// Generated by purs version 0.13.0
"use strict";
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Action_CreatureAct = require("../Ritoppu.Action.CreatureAct/index.js");
var Ritoppu_Mutation_Inventory = require("../Ritoppu.Mutation.Inventory/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var removeItem = function (item) {
    return function (game) {
        return {
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: game.stage.player.stats,
                    turn: game.stage.player.turn,
                    inventory: Ritoppu_Mutation_Inventory.removeItemFromInventory(item)(game.stage.player.inventory),
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        };
    };
};
var playerTurn = function (game) {
    return {
        stage: {
            player: {
                pos: game.stage.player.pos,
                stats: game.stage.player.stats,
                turn: game.stage.player.turn + 5 | 0,
                inventory: game.stage.player.inventory,
                level: game.stage.player.level,
                equipment: game.stage.player.equipment
            },
            tiles: game.stage.tiles,
            size: game.stage.size,
            seen: game.stage.seen,
            items: game.stage.items,
            fovMask: game.stage.fovMask,
            creatures: game.stage.creatures
        },
        dungeonLevel: game.dungeonLevel
    };
};
var dropItem = function (item) {
    return function (game) {
        var withItem = {
            stage: Ritoppu_Mutation_Stage.addItem(game.stage.player.pos)(item)(game.stage),
            dungeonLevel: game.dungeonLevel
        };
        return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.DropItem(item)))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn(removeItem(item)(withItem))));
    };
};
module.exports = {
    dropItem: dropItem
};
